/* unplugin-vue-components disabled *//* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//

import FileUploadAndroid from './FileUploadAndroid.vue';
import FileUploadComponent from './FileUploadComponent.vue';
var u = navigator.userAgent;
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
export default {
  name: 'FileUpload',
  components: {
    FileUploadAndroid: FileUploadAndroid,
    FileUploadComponent: FileUploadComponent
  },
  computed: {
    componentId: function componentId() {
      return isAndroid ? 'FileUploadAndroid' : 'FileUploadComponent';
    }
  }
};